export function usePageContentAclHooks({props,xmPageContentAcl,ctlAclInfos}){

  /**
   * 初始化按钮显示信息
   */
  const initBtnShowInfos = function (aclInfosRef) {
    if (unref(aclInfosRef)) {
      const {subPageConfigs} = unref(aclInfosRef);
      if (subPageConfigs && subPageConfigs.length > 0) {
        const selItem = subPageConfigs.filter((itemDb) => {
          return itemDb.key === unref(props).key
        })[0];
        if (selItem) {
          xmPageContentAcl.value=[selItem.configs];
        }
      }
    } else {

    }
  }
  /**
   * 控制按钮显示
   */
  const initAclInfosCtl = function () {
    if (unref(ctlAclInfos) && unref(ctlAclInfos).length > 0) {
      unref(ctlAclInfos).forEach((btnAclObj) => {
        initBtnShowInfos(btnAclObj);
      })
    }
  }
  watch(() => unref(ctlAclInfos), (newAcl) => {
    initAclInfosCtl();
  })

  onMounted(() => {
    initAclInfosCtl();
  })


  return {

  }
}
